import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Is the DM Closer actually safe to use?",
    a: "Yes. ClydeFlow uses the official Meta Graph API — fully verified, fully approved. We don't scrape, we don't impersonate, and you won't wake up to a banned account.",
  },
  {
    q: "How is this different from ChatGPT or generic AI tools?",
    a: "Generic tools ideate. ClydeFlow executes. We connect to your actual stack — content goes live, DMs get sent, ads get synced, tasks get completed. Without you babysitting.",
  },
  {
    q: "What's the Mogul Growth Package about?",
    a: "It's a one-time £299 done-for-you onboarding. Our team installs ClydeFlow across your business, sets up your local Mogul Sync network, and trains your team. Glasgow built, Glasgow supported.",
  },
  {
    q: "Can I cancel my trial?",
    a: "Anytime. No card required to start. If ClydeFlow doesn't earn its keep in 14 days, you're out — no hard feelings.",
  },
  {
    q: "Where is my data stored?",
    a: "All data is encrypted at rest in EU-region MongoDB clusters. We never sell, share, or train external models on your data.",
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="relative py-24 lg:py-32 border-t border-white/10" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-400 mb-4">
          The good questions
        </p>
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-white tracking-tighter leading-[1.05] mb-12">
          Straight answers.
          <br />
          <span className="text-slate-500">No corporate waffle.</span>
        </h2>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-heading font-bold text-lg lg:text-xl text-white hover:text-cyan-300 py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-300 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
